import { useState } from 'react';
import type { ReactNode } from 'react';
import Observer from '@researchgate/react-intersection-observer';
import { intersectorThresholds } from '@/constants/intersectorThresholds';
import { MinHeightContainer } from './styled';
import { useIntersectionObserverDisabler } from '@/context/IntersectionObserverDisabler';

type NodeOrRenderNode = ReactNode | (() => ReactNode);

export interface Props {
  skipDefer?: boolean;
  preRenderHeight?: number | string;
  preRenderHeightMdDown?: number | string;
  preRenderHeightSmDown?: number | string;
  children?: NodeOrRenderNode;
  fallback?: NodeOrRenderNode;
}

const DeferRenderUntilIntersecting = ({
  children,
  fallback,
  skipDefer,
  preRenderHeight,
  preRenderHeightMdDown,
  preRenderHeightSmDown,
}: Props) => {
  const [rendered, setRendered] = useState(false);
  const intersectionObserverDisabler = useIntersectionObserverDisabler();
  if (typeof children === 'undefined') return null;
  if (skipDefer || rendered) {
    return (
      <MinHeightContainer
        height={preRenderHeight}
        heightMdDown={preRenderHeightMdDown}
        heightSmDown={preRenderHeightSmDown}
      >
        {typeof children === 'function' ? children() : children}
      </MinHeightContainer>
    );
  }

  return (
    <Observer
      threshold={intersectorThresholds}
      onChange={({ isIntersecting }) => {
        if (isIntersecting && intersectionObserverDisabler.enabled) {
          setRendered(true);
        }
      }}
    >
      <MinHeightContainer
        height={preRenderHeight}
        heightMdDown={preRenderHeightMdDown}
        heightSmDown={preRenderHeightSmDown}
      >
        {typeof fallback === 'function' ? fallback() : fallback}
      </MinHeightContainer>
    </Observer>
  );
};

export default DeferRenderUntilIntersecting;
